const diferenciais = [
  {
    icon: "ri-timer-flash-line",
    title: "Atendimento Rápido",
    description:
      "Respondemos no mesmo dia e avaliamos seu caso com agilidade. Seu problema não pode esperar e nós sabemos disso.",
  },
  {
    icon: "ri-focus-3-line",
    title: "Estratégia Personalizada",
    description:
      "Cada caso é único. Desenvolvemos uma estratégia jurídica específica para o seu perfil e tipo de contrato bancário.",
  },
  {
    icon: "ri-trophy-line",
    title: "Foco em Resultado",
    description:
      "Trabalhamos orientados a resultado concreto: redução de dívida, recuperação de valores ou revisão de juros abusivos garantida.",
  },
  {
    icon: "ri-eye-line",
    title: "Clareza no Processo",
    description:
      "Você sempre sabe o que está acontecendo. Comunicação clara, sem juridiquês, em todas as etapas do seu processo.",
  },
  {
    icon: "ri-shield-user-line",
    title: "Compromisso Ético",
    description:
      "Atuação plenamente dentro das normas da OAB, com ética, transparência e respeito ao cliente em todos os momentos.",
  },
  {
    icon: "ri-map-pin-line",
    title: "Atendimento Local e Online",
    description:
      "Escritório em Nova Prata – RS com atendimento presencial e remoto para clientes de todo o Brasil.",
  },
];

export default function Diferenciais() {
  return (
    <section className="py-24 bg-[#F9F9F9]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
          <div>
            <span className="text-[#B32025] text-xs font-semibold uppercase tracking-widest font-sans">
              Por que nos escolher
            </span>
            <h2 className="font-serif text-[#1A1A1A] text-3xl lg:text-4xl font-bold mt-3">
              Nossos Diferenciais
            </h2>
          </div>
          <p className="text-[#2C2C2C]/70 text-base leading-relaxed font-sans lg:max-w-sm">
            O que nos distingue na atuação em revisão de juros e defesa dos direitos do consumidor bancário.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {diferenciais.map((d) => (
            <div
              key={d.title}
              className="group bg-white border border-[#E6E6E6] hover:border-[#B32025]/30 rounded-lg p-7 transition-all duration-300 cursor-default"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0 bg-[#B32025]/8 group-hover:bg-[#B32025]/15 rounded-lg transition-colors">
                  <i className={`${d.icon} text-2xl text-[#B32025] leading-none`} />
                </div>
                <div>
                  <h3 className="font-serif text-[#1A1A1A] text-lg font-bold mb-2">{d.title}</h3>
                  <p className="text-[#2C2C2C]/70 text-sm leading-relaxed font-sans">{d.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
